import MainSection from '../Components/Sections/Main.Section';
import DescriptionSection from '../Components/Sections/DescriptionSection';
import ProductsExampleSection from '../Components/Sections/Products-example.section';
import ShowreelSection from '../Components/Sections/Showreel.Section';
import {AccessBtnComponent} from '../Components/access-btn.component';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {Helmet} from '@dr.pogodin/react-helmet';

const imgs = ['https://storage.googleapis.com/lesia-k/Pictures/1430x350_banner1.png', 'https://storage.googleapis.com/lesia-k/Pictures/1430x350_banner2.png',];
const sliderSettings = {
    dots: true, // Enable navigation dots
    infinite: true, // Infinite loop
    speed: 500, // Transition speed
    slidesToShow: 1, // Show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay interval
    fade: true, // Add fade effect
    arrows: false, // Hide navigation arrows
};

export function IndexPage() {


    return (
            <div>
                <MainSection/>
                <ProductsExampleSection/>
                <ShowreelSection title={'2026'}
                                 videoUrl={'https://storage.googleapis.com/lesia-k/videos/showreel_2026.mp4'}/>
                <ShowreelSection title={'2025'}/>
                {/*<CardsPage/>*/}
                <DescriptionSection
                    title={"Services Offered"}
                    showService
                    children={<AccessBtnComponent text="Contact Now"
                                                  className="px-20 md:px-24 py-8 border-2 border-pink-700 rounded-xl text-white relative mt-6 text-lg bg-pink-600 font-semibold"/>}/>
                {/*<DescriptionSection showProcess title={"Easy process"}/>*/}
                {/*<PackagePage/>*/}

                <div className={"w-full"}>
                    <Slider {...sliderSettings} className="w-full">
                        {imgs.map((img, index) => (
                            <div key={index} className="relative">
                                <img
                                    src={img}
                                    alt={`Slide ${index + 1}`}
                                    className="w-full h-auto object-cover rounded-lg shadow-lg"
                                />
                                <div
                                    className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black opacity-50"></div>
                            </div>
                        ))}
                    </Slider>
                </div>

            </div>

    );
}
